{"languageLabel":"Tiếng Việt","menu":{"home":"Trang chủ","products":"Sản phẩm","contact":"Liên hệ"}}